module.exports = __webpack_public_path__ + "img/expertAuth.b3fadd0e.png";